// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
// The developer tools (E21U1): any dev or staging build, signed in or out; production only for platform staff, whom
// a `/me` with `platform` names — everyone else there gets NotFound, as the platform area does.
import { createFileRoute, notFound } from '@tanstack/react-router'
import { DevMenu } from '../features/devtools/DevMenu'
import { meQuery } from '../shared/org/me'

export const Route = createFileRoute('/dev')({
  staticData: { screenId: 'DevMenuScreen', access: 'dev builds; super admin in production' },
  beforeLoad: async ({ context: { queryClient } }) => {
    if (import.meta.env.VITE_ORCA_ENV !== 'prod') return
    const me = await queryClient.ensureQueryData(meQuery())
    if (!me?.platform) throw notFound()
  },
  component: DevMenu,
})
